import React from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useRemoveInitiative } from 'src/graphql/hooks'

const InitiativeDeleteConfirm = ({
   initiativeId,
   initiativeName,
   onCancelButtonClick,
   onDelete
}) => {
   const { removeInitiative, mutating } = useRemoveInitiative()

   const handleDeleteInitiative = async () => {
      await removeInitiative({ id: initiativeId })

      if (onDelete) {
         onDelete()
      }
   }

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="18px"
            borderBottom="1px solid #eee">
            <Text size="3" weight="medium">
               Confirm Deletion
            </Text>
         </View>
         <View padding="18px" textAlign="center">
            <View>
               <Text size="2" color="#444">
                  Are you sure you want to delete&nbsp;
                  <b>{initiativeName}</b>
                  ? This action cannot be undone.
               </Text>
               <Spacer size="2" />
            </View>
            <Spacer size="3" />
            <View display="flex" justifyContent="flex-end">
               <Button
                  onClick={onCancelButtonClick}
                  width="48%"
                  size="sm"
                  name="Cancel"
                  color="#fff"
                  textColor="#666"
               />
               <View display="inline-block" width="2%" height="12px" />
               <Button
                  onClick={handleDeleteInitiative}
                  width="50%"
                  size="sm"
                  type="submit"
                  name="Delete"
                  color="#ee5248"
                  textColor="#fff"
                  mode={mutating ? 'loading' : 'normal'}
               />
            </View>
         </View>
      </View>
   )
}

InitiativeDeleteConfirm.propTypes = {
   initiativeId: PropTypes.string.isRequired,
   initiativeName: PropTypes.string.isRequired,
   onCancelButtonClick: PropTypes.func.isRequired,
   onDelete: PropTypes.func.isRequired
}

export default InitiativeDeleteConfirm
